const FIELD_PROPS = {
  PHONE: {
    placeholder: '10 digits',
    maxLength: '10',
    inputMode: 'numeric',
    helpText: '10 digits, no dashes',
  },
  DOB: {
    label: 'Date of Birth',
    placeholder: 'MM/DD/YYYY',
    maxLength: '10',
    errorMessage: 'Date must be in MM/DD/YYYY format, and year must be greater than 1900',
    helpText: 'Invalid Date',
  },
  ownerPercent: {
    type: 'number',
    label: 'Ownership percentage',
    placeholder: '%',
    errorMessage: 'Ownership percentage must be a number between 0 and 100',
    helpText: 'Invalid Percentage',
    max: 100,
  },
};

export default FIELD_PROPS;
